<template>
  <v-container class="orders-container">
    <span class="ma-3">
      <TitleChip title="Pedidos" />
    </span>
    <v-tabs
      v-model="selectedTab"
      centered
      fixed-tabs
      class="tabs-header mt-2"
    >
      <v-tabs-slider color="#140C22" />
      <v-tab href="#abertos">
        Abertos
      </v-tab>
      <v-tab href="#resolvidos">
        Resolvidos
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="selectedTab">
      <v-tab-item value="abertos">
        <OrderCard
          v-for="openOrder in openOrders"
          :key="openOrder._id"
          :order="openOrder"
        />
        <span
          v-if="!openOrders.length"
          class="no-orders-text"
        >
          Você não tem pedidos abertos...
        </span>
      </v-tab-item>
      <v-tab-item value="resolvidos">
        <OrderCard
          v-for="closeOrder in closeOrders"
          :key="closeOrder._id"
          :order="closeOrder"
        />
        <span
          v-if="!closeOrders.length"
          class="no-orders-text"
        >
          Você não tem pedidos resolvidos...
        </span>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import _ from 'lodash';
import { everything } from '@sejazipper/layer-api-client';
import { mapGetters } from 'vuex';
import { useZipperApi } from '../composables/useZipperApi';

const { client } = useZipperApi();

export default {
  data: () => ({
    orders: [],
    selectedTab: 'abertos',
  }),
  computed: {
    ...mapGetters(['getStore', 'isManager', 'isDirector']),
    openOrders() {
      return this.orders.filter((o) => !o.resolved);
    },
    closeOrders() {
      return this.orders.filter((o) => o.resolved);
    },
  },
  async mounted() {
    const sellerId = (this.isManager || this.isDirector) ? null : this.$auth.user.sub;
    this.orders = await client.chain.query
      .getLeadCustomersBySellerAndStore({
        sellerId,
        storeId: this.getStore.id,
      })
      .get({
        ...everything,
        cart: {
          ...everything,
          products: {
            ...everything,
          },
        },
      });
    this.$store.dispatch('setOrders', _.groupBy(this.orders, '_id'));
  },
};
</script>

<style lang="scss" scoped>
.orders-container {
  padding: 10px 0 80px 0;
}

.tabs-header{
  font-family: 'Neue-Metana';
  font-size: 18px;
}

.no-orders-text {
  display: block;
  font-family: 'Nunito Sans';
  font-size: 16px;
  text-align: center;
  margin-top: 30px;
}
</style>
